import {
  ApiError,
  ClinicDetails,
  ClinicSearchResults,
  GetClinicsPayload,
} from '@core/models';

import { createAction, props } from '@ngrx/store';

export enum ClinicActionTypes {
  CLEAR_CLINIC_DETAILS_REQUEST = '[ClinicSearch] Clear Clinic Details',
  GET_CLINICS = '[ClinicSearch] Get Clinics',
  GET_CLINICS_SUCCESS = '[ClinicSearch] Get Clinics Success',
  GET_CLINICS_FAILURE = '[ClinicSearch] Get Clinics Failure',
  GET_CLINIC_DETAILS = '[ClinicSearch] Get clinic details',
  GET_CLINIC_DETAILS_SUCCESS = '[ClinicSearch] Get clinic details success',
  GET_CLINIC_DETAILS_FAILURE = '[ClinicSearch] Get clinic details failure',
  GET_SEARCH_ADDRESS = '[ClinicSearch] Get Search Address',
  UPDATE_SEARCH_ADDRESS = '[ClinicSearch] Update Search Address',
}

export const clearClinicDetails = createAction(
  ClinicActionTypes.CLEAR_CLINIC_DETAILS_REQUEST,
);

export const getClinics = createAction(
  ClinicActionTypes.GET_CLINICS,
  props<{ payload: GetClinicsPayload }>(),
);
export const getClinicsSuccess = createAction(
  ClinicActionTypes.GET_CLINICS_SUCCESS,
  props<{ clinicSearchResults: ClinicSearchResults }>(),
);
export const getClinicsFailure = createAction(
  ClinicActionTypes.GET_CLINICS_FAILURE,
  props<ApiError>(),
);

export const getClinicDetails = createAction(
  ClinicActionTypes.GET_CLINIC_DETAILS,
  props<{ clinicId: string }>(),
);
export const getClinicDetailsSuccess = createAction(
  ClinicActionTypes.GET_CLINIC_DETAILS_SUCCESS,
  props<{ clinicDetails: ClinicDetails }>(),
);
export const getClinicDetailsFailure = createAction(
  ClinicActionTypes.GET_CLINIC_DETAILS_FAILURE,
  props<ApiError>(),
);

export const getSearchAddress = createAction(
  ClinicActionTypes.GET_SEARCH_ADDRESS,
  props<{ searchAddress: string }>(),
);
export const updateSearchAddress = createAction(
  ClinicActionTypes.UPDATE_SEARCH_ADDRESS,
  props<{ searchAddress: string }>(),
);
